import { WishlistProvider } from '@context/WishlistContext'
import { ImageKitProvider } from '@context/ImageKitContext'
import { CartProvider } from '@context/CartContext'
import Routes from '@routes/Routes'
import '@styles/Globals.css'

function App() {
  return (
    <ImageKitProvider>
      <CartProvider>
        <WishlistProvider>
          <Routes />
        </WishlistProvider>
      </CartProvider>
    </ImageKitProvider>
  )
}

export default App
